import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

// Modules material
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { DialogDeleteComponent } from './dialog-delete/dialog-delete.component';
import { FileDragNDropDirective } from './file-drag-n-drop.directive';

@Component({
  selector: 'lib-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatSnackBarModule,
    FormsModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatButtonModule,
    MatListModule,
    MatDialogModule,
    FileDragNDropDirective
  ]
})
export class UploadFileComponent {

  @Input()
  acceptFile: string = "image/*";

  @Input()
  allowedExtensions: string = "(jpg|png|svg)";

  @Input()
  clean: Boolean = false;

  @Output()
  fileUpload: any = new EventEmitter<any>();

  @Output()
  isEmpty: any = new EventEmitter<boolean>();

  public files: any[] = [];

  constructor(
    private _snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { }

  onFileChange(pFileList: any, dropZone: boolean = false) {
    let files: any = null;
    if (dropZone) {
      files = pFileList;
    } else {
      files = pFileList.target.files;
    }

    try {
      const allowedExtensions = new RegExp(`^.*\.${this.allowedExtensions}$`);

      if (!allowedExtensions.test(files[0].name)) {
        this._snackBar.open("Formato no válido", 'Cerrar', {
          duration: 2000,
        });
      } else {
        // this.files = Object.keys(files).map((key: any) => files[key]);
        this.files.push(files[0]);
        this.fileUpload.emit(this.files[0]);
        this.isEmpty.emit(false)
        this._snackBar.open("Carga exitosa", 'Cerrar', {
          duration: 2000,
        });
        if(this.clean){
          setTimeout(() => {
            this.files = [];
          }, 2500);
        }
      }
    } catch { }
  }

  openConfirmDialog(pIndex: any): void {
    const dialogRef = this.dialog.open(DialogDeleteComponent, {
      panelClass: 'modal-xs'
    });
    dialogRef.componentInstance.fName = this.files[pIndex].name;
    dialogRef.componentInstance.fIndex = pIndex;

    dialogRef.afterClosed().subscribe((result: any) => {

      if (result !== undefined) {
        this.fileUpload.emit(null);
        this.deleteFromArray(result);
      }
    });
  }

  deleteFromArray(index: any) {
    this.files.splice(index, 1);
  }
}
